import React from "react";
import { Button, Flex } from "@chakra-ui/react";
import { Plus } from "lucide-react";
import AllReportsTable from "./AllReportsTable";

const AllReports = ({ reportManager }) => {


  

  return (
    <Flex direction="column" p={0} w={"100%"} gap={8}>
      <Flex justifyContent="space-between" direction={{ lg: "row", base: "column" }} gap={4}>
        <h1>All reports</h1>
        <Button
          onClick={reportManager.openNewReportModal}
          w={"fit-content"}
          leftIcon={<Plus size={16} />}
        >
          New report
        </Button>
      </Flex>
      
      <AllReportsTable reportManager={reportManager} />
      
    </Flex>
  );
};

export default AllReports;
